export interface UserDataState {
    user: UserData | null | undefined;
    userSettings: ShiftSettings | null | undefined;
    employData: EmployData | null | undefined;
    employVacationData: EmployVacationData[];
    isAdmin: boolean;
    isWDP: boolean;
    isUP: boolean;
    rawUserData: any | null | undefined;
    environment: string | undefined;
    firebase_function: string | undefined
}

const state: UserDataState = {
    user: undefined,
    userSettings: undefined,
    employData: undefined,
    rawUserData: undefined,
    environment: undefined,
    firebase_function: undefined,
    employVacationData: [],
    isAdmin: false,
    isWDP: false,
    isUP: false
};

const getters = {
    loggedIn: (state: UserDataState): boolean | undefined =>
        state.user === undefined ? undefined : state.user !== null,

    userName: (state: UserDataState): string =>
        state.user ? `${state.user.name} ${state.user.family_name}` : '',

    userId: (state: UserDataState): string | undefined =>
        state.user ? state.user.sub : undefined,
    
    emplno: (state: UserDataState): string | undefined =>
        state.user ? state.user.emplno : undefined,
    
    isAdmin: (state: UserDataState): boolean => state.user?.isAdmin || false,

    isWDP: (state: UserDataState): boolean => state.user?.isWDP || state.user?.EmployData?.isWDP || false,

    isUP: (state: UserDataState): boolean => state.user?.isUP || state.user?.EmployData?.isUp || false,
    
    rawEmail: (state: UserDataState): string | undefined => state.rawUserData?.email,

    rawUUID: (state: UserDataState): string | undefined => state.rawUserData?.uuid,
    
    environment: (state: UserDataState): string | undefined => state.environment,

    firebase_function: (state: UserDataState): string | undefined => state.firebase_function,
};

const mutations = {
    SET_USER(state: UserDataState, user: UserData | null) {
        state.user = user;
    },
    SET_USERSETTINGS(state: UserDataState, userSettings: ShiftSettings | null) {
        state.userSettings = userSettings;
    },
    SET_EMPLOYDATA(state: UserDataState, employData: EmployData | null) {
        state.employData = employData;
    },
    SET_RAWUSERDATA(state: UserDataState, rawUserData: any | null) {
        state.rawUserData = rawUserData;
    },
    SET_ENVIRONMENT(state: UserDataState, environment: string) {
        state.environment = environment;
    },
    SET_FIREBASE_FUNCTION(state: UserDataState, firebase_function: string) {
        state.firebase_function = firebase_function;
    },
    PUSH_VACATIONDATA(state: UserDataState, employVacationData: EmployVacationData[]) {
        state.employVacationData.push(...employVacationData);
    },
    SET_VACATIONDATA(state: UserDataState, employVacationData: EmployVacationData[]) {
        state.employVacationData = employVacationData;
    }
};

export default {
    state,
    getters,
    mutations
};